<template>
  <v-container
    class="my-6"
  >
    <v-row
      align="start"
      justify="center"
      class="text-center mb-1"
    >
      <v-col>
        <v-icon x-large class="green--text">
          monetization_on
        </v-icon>
        <h2 class="display-2 my-2">
          Finanz&shy;übersicht
        </h2>
      </v-col>
    </v-row>
    <page-loading :is-page-loading="$store.state.pageLoading" />

    <v-row
      justify="center"
      align="start"
      class="my-4"
    >
      <v-col
        cols="12"
        sm="5"
      >
        <v-card>
          <v-toolbar dark class="primary">
            <v-toolbar-title>Girokonto</v-toolbar-title>
            <v-spacer />
            <b class="title">{{ $store.state.moneyStore.giro | currency }}</b>
          </v-toolbar>
          <v-card-text>
            <p class="body-1 text-center mb-6">
              Möchtest du Geld von deinem Girokonto<br> auf das Sparkonto umbuchen und anlegen?
            </p>
            <v-text-field
              v-model="sparBetrag"
              name="money"
              label="Wieviel Geld willst du umbuchen?"
              prepend-icon="monetization_on"
            />

            <v-select
              :items="anlageItems"
              v-model="sparDauer"
              label="Wie lange willst du das Geld anlegen?"
              prepend-icon="mdi-clock"
            />

            <p class="headline text-center my-6">
              Am Ende erhälst du <b>{{ sparBetragEnde | currency }}</b>
            </p>
            <br>
            <p class="text-center">
              <v-btn
                :loading="$store.state.loading"
                :disabled="$store.state.loading"
                color="primary"
                @click.native.stop="transferMoney()"
              >
                Aufs Sparkonto buchen
                <v-icon right dark>
                  mdi-transfer
                </v-icon>
              </v-btn>
            </p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="7"
      >
        <v-card>
          <v-toolbar dark class="primary">
            <v-toolbar-title>Sparkonto</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="sparHeaders"
              :items="sparItems"
              hide-default-footer
              class="elevation-1 text-center"
            >
              <template v-slot:item="{ item }">
                <td>{{ item.betrag | currency }}</td>
                <td>{{ item.since }}</td>
                <td>{{ item.dauer | plural('Spieltag', 'Spieltage') }}</td>
                <td>{{ item.betrag | calculateAuszahlBetrag(item.zinsen) | currency }}</td>
                <td>
                  {{ item.status | plural('Spieltag', 'Spieltage') }}
                  <v-progress-linear
                    :value="item.status | calculateRestdauer(item.dauer)"
                    class="mb-1 mt-1"
                  />
                </td>
              </template>

              <template slot="no-data">
                <v-alert
                  color="warning"
                  icon="warning"
                >
                  Keine Geldanlage vorhanden, tätige eine Überweisung um hier was zu erkennen.
                </v-alert>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      class="my-12"
    >
      <v-col
        cols="12"
      >
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Spieltags-Übersicht</v-toolbar-title>
          <v-spacer />
          <v-btn
            text
            icon
            @click="visibilitySpieltag = !visibilitySpieltag"
          >
            <v-icon v-if="visibilitySpieltag===true">
              keyboard_arrow_up
            </v-icon>
            <v-icon v-else>
              keyboard_arrow_down
            </v-icon>
          </v-btn>
        </v-toolbar>
      </v-col>

      <v-col
        v-show="visibilitySpieltag"
        cols="12"
        sm="6"
      >
        <v-card>
          <v-toolbar color="green darken-3" dark>
            <v-toolbar-title>Feste Einnahmen</v-toolbar-title>
            <v-spacer />
            <b class="title">{{ $store.getters['moneyStore/getSponsorDayMoney'] | currency }}</b>
          </v-toolbar>
          <v-list>
            <v-list-item>
              <v-list-item-action>
                <v-icon>local_activity</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Hauptsponsor</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ $store.getters['moneyStore/getSponsorDayMoney'] | currency }}
              </v-list-item-action>
            </v-list-item>
            <!-- <v-list-item>
                <v-list-item-action>
                  <v-icon>local_activity</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Trikotwerbung</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  {{ "1000" | currency}}
                </v-list-item-action>
            </v-list-item>

            <v-list-item>
                <v-list-item-action>
                  <v-icon>local_activity</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Bandenwerbung</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  {{ "1000" | currency}}
                </v-list-item-action>
            </v-list-item>

            <v-list-item>
                <v-list-item-action>
                  <v-icon>local_activity</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Fahrzeugwerbung</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  {{ "1000" | currency}}
                </v-list-item-action>
            </v-list-item> -->
          </v-list>
        </v-card>
      </v-col>

      <v-col
        v-show="visibilitySpieltag"
        cols="12"
        sm="6"
        transition="slide-y-transition"
      >
        <v-card>
          <v-toolbar color="red darken-3" dark>
            <v-toolbar-title>Fixe Ausgaben</v-toolbar-title>
            <v-spacer />
            <b class="title">{{ $store.getters['teamStore/getSallary'] | currency }}</b>
          </v-toolbar>
          <v-list>
            <v-list-item>
              <v-list-item-action>
                <v-icon>local_activity</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Spielergehälter</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ $store.getters['teamStore/getSallary'] | currency }}
              </v-list-item-action>
            </v-list-item>

            <!-- <v-list-item>
                <v-list-item-action>
                  <v-icon>local_activity</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Managergehalt</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  {{ "1000" | currency}}
                </v-list-item-action>
            </v-list-item> -->

            <!-- <v-list-item>
                <v-list-item-action>
                  <v-icon>local_activity</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Angesteltengehalt</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  {{ "1000" | currency}}
                </v-list-item-action>
            </v-list-item> -->
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      class="my-12"
    >
      <v-col
        cols="12"
      >
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Saison-Übersicht</v-toolbar-title>
          <v-spacer />
          <v-btn
            text
            icon
            @click="visibilitySaison = !visibilitySaison"
          >
            <v-icon v-if="visibilitySaison===true">
              keyboard_arrow_up
            </v-icon>
            <v-icon v-else>
              keyboard_arrow_down
            </v-icon>
          </v-btn>
        </v-toolbar>
      </v-col>

      <v-col
        v-show="visibilitySaison"
        cols="12"
        sm="6"
      >
        <v-card>
          <v-toolbar color="green darken-3" dark>
            <v-toolbar-title>Gesamteinnahmen</v-toolbar-title>
            <v-spacer />
            <b class="title">{{ $store.getters['moneyStore/allSaisonEinnahmen'] | currency }}</b>
          </v-toolbar>
          <v-list>
            <v-list-item
              v-for="(item, key) in $store.getters['moneyStore/getSaisonEinnahmen']"
              :key="key"
            >
              <v-list-item-action>
                <v-icon>local_activity</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.item }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item.value | currency }}
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col
        v-show="visibilitySaison"
        cols="12"
        sm="6"
      >
        <v-card>
          <v-toolbar color="red darken-3" dark>
            <v-toolbar-title>Gesamtausgaben</v-toolbar-title>
            <v-spacer />
            <b class="title">{{ $store.getters['moneyStore/allSaisonAusgaben'] | currency }}</b>
          </v-toolbar>
          <v-list>
            <v-list-item
              v-for="(item, key) in $store.getters['moneyStore/getSaisonAusgaben']"
              :key="key"
            >
              <v-list-item-action>
                <v-icon>local_activity</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.item }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item.value | currency }}
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      class="my-12"
    >
      <v-col
        cols="12"
      >
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Lifetime-Übersicht</v-toolbar-title>
          <v-spacer />
          <v-btn
            text
            icon
            @click="visibilityLifetime = !visibilityLifetime"
          >
            <v-icon v-if="visibilityLifetime===true">
              keyboard_arrow_up
            </v-icon>
            <v-icon v-else>
              keyboard_arrow_down
            </v-icon>
          </v-btn>
        </v-toolbar>
      </v-col>
      <v-col
        v-show="visibilityLifetime"
        cols="12"
        sm="6"
      >
        <v-card>
          <v-toolbar color="green darken-3" dark>
            <v-toolbar-title>Gesamteinnahmen</v-toolbar-title>
            <v-spacer />
            <b class="title">{{ $store.getters['moneyStore/allLifetimeEinnahmen'] | currency }}</b>
          </v-toolbar>
          <v-list>
            <v-list-item
              v-for="(item, key) in $store.getters['moneyStore/getLifetimeEinnahmen']"
              :key="key"
            >
              <v-list-item-action>
                <v-icon>local_activity</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.item }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item.value | currency }}
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col
        v-show="visibilityLifetime"
        cols="12"
        sm="6"
      >
        <v-card>
          <v-toolbar color="red darken-3" dark>
            <v-toolbar-title>Gesamtausgaben</v-toolbar-title>
            <v-spacer />
            <b class="title">{{ $store.getters['moneyStore/allLifetimeAusgaben'] | currency }}</b>
          </v-toolbar>
          <v-list>
            <v-list-item
              v-for="(item, key) in $store.getters['moneyStore/getLifetimeAusgaben']"
              :key="key"
            >
              <v-list-item-action>
                <v-icon>local_activity</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.item }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item.value | currency }}
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      justify="center"
    >
      <v-col
        cols="10"
      >
        <v-card
          elevation="1"
          raised
        >
          <v-card-title class="primary white--text mb-4">
            Dein gewählter Sponsor
          </v-card-title>
          <v-card-text>
            <h4 class="headline font-weight-black black--text">
              {{ $store.state.moneyStore.sponsor.name }}
            </h4>
            <p class="caption">
              Beträge die Du für die einzelnen Wettbewerbe erhälst.
            </p>
            <v-row
              justify="space-around"
            >
              <v-col>
                <b>Spieltag</b><br>
                {{ $store.state.moneyStore.sponsor.spieltag | currency }}
              </v-col>
              <v-col>
                <b>Meisterschaft</b><br>
                {{ $store.state.moneyStore.sponsor.meisterschaft | currency }}
              </v-col>
              <v-col>
                <b>Platz 2</b><br>
                {{ $store.state.moneyStore.sponsor.platz2 | currency }}
              </v-col>

              <v-col>
                <b>Klassenerhalt</b><br>
                {{ $store.state.moneyStore.sponsor.klassenerhalt | currency }}
              </v-col>

              <v-col>
                <b>Einzel&shy;meisterschaft</b><br>
                {{ $store.state.moneyStore.sponsor.einzelmeisterschaft | currency }}
              </v-col>

              <v-col>
                <b>Pokal</b><br>
                {{ $store.state.moneyStore.sponsor.pokal | currency }}
              </v-col>

              <v-col>
                <b>Trainingspunkte</b><br>
                {{ $store.state.moneyStore.sponsor.tp }}
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mx-4" />
          <v-card-actions />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Finanzen',
  metaInfo: {
    title: 'Finanzen'
  },
  data () {
    return {
      visibilitySpieltag: true,
      visibilitySaison: true,
      visibilityLifetime: true,
      anlageItems: [
        { text: '1 Spieltag', value: 0.01 },
        { text: '5 Spieltage', value: 0.05 },
        { text: '10 Spieltage', value: 0.1 },
        { text: '20 Spieltage', value: 0.25 },
        { text: '30 Spieltage', value: 0.40 }
      ],
      sparBetrag: 0,
      sparBetragEnde: 0,
      sparDauer: 0,
      sparHeaders: [
        {
          text: 'Anlagebetrag',
          sortable: true,
          value: 'betrag'
        },
        { text: 'Angelegt am', value: 'since', sortable: false },
        { text: 'AnlageDauer', value: 'dauer' },
        { text: 'Auszahlbetrag', value: 'auszahlBetrag', sortable: false },
        { text: 'Auszahlung in x Tagen', value: 'status' }
      ],
      sparItems: []
    }
  },
  filters: {
    calculateAuszahlBetrag: function (betrag, multiplikator) {
      let value = betrag
      if (!value) return 0
      value = value + (value * multiplikator)
      return Math.ceil(value)
    },
    calculateRestdauer: function (restDauer, gesamtDauer) {
      return Math.ceil(100 - ((restDauer / gesamtDauer) * 100))
    },
    plural: function (value, einzahl, mehrzahl) {
      if (value > 1) {
        return value + ' ' + mehrzahl
      }
      return value + ' ' + einzahl
    }
  },
  watch: {
    sparBetrag: function (value) {
      let amount = value
      amount = amount + ' '
      amount = amount.replace(/[^0-9]/g, '')

      if (amount === '' || amount.length === 0) {
        amount = '0'
      }
      amount = amount * 1

      if (amount < 0) {
        amount = 0
      }

      if (amount >= this.$store.state.moneyStore.giro) {
        amount = this.$store.state.moneyStore.giro
      }

      this.sparBetrag = amount
      this.sparBetragEnde = Math.ceil(this.sparDauer * this.sparBetrag) + this.sparBetrag
    },
    sparDauer: function (value) {
      this.sparBetragEnde = Math.ceil(value * this.sparBetrag) + this.sparBetrag
    }
  },
  methods: {
    transferMoney: async function () {
      let spieltage = 1
      switch (this.sparDauer) {
        case 0.01:
          spieltage = 1
          break
        case 0.05:
          spieltage = 5
          break
        case 0.1:
          spieltage = 10
          break
        case 0.25:
          spieltage = 20
          break
        case 0.40:
          spieltage = 30
          break
        default:
          return false
      }

      if (parseInt(this.sparBetrag, 10) < 1) {
        return false
      }
      const sparItem = {
        betrag: this.sparBetrag,
        dauer: spieltage,
        zinsen: this.sparDauer,
        status: spieltage
      }
      if (await this.$store.dispatch('moneyStore/saveSparbetrag', sparItem)) {
        // set new sparItems
        this.sparItems = this.$store.state.moneyStore.spar
        this.sparBetrag = 0
        this.sparBetragEnde = 0
        this.sparDauer = 0
      }
    }
  },
  mounted: async function () {
    // load all finanzial data
    if (await this.$store.dispatch('moneyStore/getUserFinanzen')) {
      this.sparItems = this.$store.state.moneyStore.spar
    }
  }
}
</script>
<style scoped>

</style>
